module.exports = __webpack_public_path__ + "img/d-bg.bfe9e599.png";